import {useLottie} from 'lottie-react';
import animation from "./animation.json"

const Loading = () => {

  const options = {
    animationData: animation,
    loop: true,
    autoplay: true,
  };

  const { View } = useLottie(options);

  return View;

}

export default Loading